import * as React from "react";
// @ts-ignore
import { ReactComponent as CheckPath } from "../../../../../components/atoms/LiveBanner/assets/check.svg";

type CircleType = "passed" | "active" | "inactive";
type DataStepType = {
  title: string;
  key: string;
};

interface Props {
  data: DataStepType[];
  currentStep: number;
}

const StepperFormRegistration: React.FC<Props> = ({
  data = [],
  currentStep = 0,
}) => {
  const dataPercentage = React.useMemo(() => {
    const dataLength = data?.length - 1;
    const progressPercentage = (currentStep / dataLength) * 100;

    return progressPercentage > 100 ? 100 : progressPercentage;
  }, [currentStep]);

  const _renderCircle = (type: CircleType, index: number) => {
    if (type === "active")
      return (
        <React.Fragment>
          <div className="w-[24px] h-[24px] bg-[#00BCF1] rounded-full flex justify-center items-center">
            <div className="w-[80%] h-[80%] bg-[#0397C9] rounded-full border-2 border-[#fff] flex items-center justify-center">
              <p className="text-[12px] text-white font-semibold leading-none relative top-[1px]">
                {index}
              </p>
            </div>
          </div>
        </React.Fragment>
      );

    if (type === "passed")
      return (
        <React.Fragment>
          <div className="w-[24px] h-[24px] bg-[#00BCF1] rounded-full flex justify-center items-center">
            <CheckPath />
          </div>
        </React.Fragment>
      );

    return (
      <React.Fragment>
        <div className="w-[24px] h-[24px] bg-[#DDE2E8] rounded-full flex justify-center items-center">
          <div className="w-[78%] h-[78%] bg-[#F0F2F9] rounded-full flex items-center justify-center">
            <p className="text-[12px] text-[#6A7481] font-semibold leading-none relative top-[1px]">
              {index}
            </p>
          </div>
        </div>
      </React.Fragment>
    );
  };

  return (
    <div className="flex flex-col h-[70px] w-[100vw max-w-[600px] bg-no-repeat pt-[14px] pb-[8px] pr-[24px]">
      <div className="flex justify-between items-center z-1">
        {data?.map((step, idx) => {
          const status = () => {
            if (currentStep > idx) return "passed";
            if (currentStep === idx) return "active";

            return "inactive";
          };

          const textClassName =
            status() === "active"
              ? "leading-none text-[10px] text-[#F48120] font-semibold"
              : "leading-none text-[10px] text-[#6A7481] font-semibold";

          return (
            <div className="flex flex-col w-[25%] items-center gap-y-[8px]">
              {_renderCircle(status(), idx + 1)}
              <p className={textClassName}>{step?.title}</p>
            </div>
          );
        })}
      </div>

      <div className="relative top-[-32px] w-[75%] left-[12.5%] h-[4px] bg-[#DDE2E8]">
        <div
          style={{ width: `${dataPercentage ?? 0}%` }}
          className={`h-[4px] bg-[#00BCF1]`}
        />
      </div>
    </div>
  );
};

export default StepperFormRegistration;
